export default __webpack_public_path__ + "static/media/paymentLink.f7d07cc8.png";